import creatorSdk from '@src/services/creator-sdk';
import * as ecc from 'eosjs-ecc';
import { PublicKey } from 'eosjs-ecc';
import { getUserIdByUsername } from '../user/helpers';

export interface KeyPair {
    publicKey: string;
    privateKey: string;
}

export function generateKeyPairDeprecated(username: string, password: string): KeyPair {
    const seed = Buffer.from(`${username}--@--${password}--@--${creatorSdk.operatorName}--@--${creatorSdk.operatorSalt}`).toString('hex');
    const privateKey = ecc.seedPrivate(seed);
    const publicKey = ecc.privateToPublic(privateKey);

    return {
        publicKey: publicKey,
        privateKey: privateKey,
    };
}

export function generateKeyPair(userId: string, password: string): KeyPair {
    const seed = Buffer.from(`${userId}--@--${password}--@--${creatorSdk.getOperatorName()}--@--${creatorSdk.getOperatorSalt()}`).toString('hex');
    const privateKey = ecc.seedPrivate(seed);
    const publicKey = ecc.privateToPublic(privateKey);

    return {
        publicKey: publicKey,
        privateKey: privateKey,
    };
}

export async function verifyUsernameAndPasswordApiCall(username: string, password: string, domainName: string) {
    const userId = getUserIdByUsername(username, domainName);
    const user = await creatorSdk.accountModule.getUser(userId);
    const keyPair = user.passVer ? generateKeyPair(userId, password) : generateKeyPairDeprecated(username, password);

    if (PublicKey(user.primaryPublicKey).toString() !== keyPair.publicKey && PublicKey(user.secondaryPublicKey).toString() !== keyPair.publicKey)
        throw new Error(`invalidPasswordWrongPublicKey - ${keyPair.publicKey}`);

    return { user, keyPair };
}
